<template>
    <q-page class="row bg-primary">
        <div class="col-12" :class="{ 'row items-center justify-center': centered, 'layout-padding': padding }" @click="yourClickHandler">
            <slot></slot>
        </div>
    </q-page>
</template>

<script>
    // import {mapGetters} from 'vuex'
    // import {loadMessages} from '../plugins/i18n'
    import {QPage, Cookies} from 'quasar-framework'
    import moment from 'moment'
    // import axios from 'axios'

    export default {
        name: 'Page',

        // data: () => ({
        //     lang: 'lang'+window.config.locale.toUpperCase(),
        // }),

        props: {
            padding: Boolean,
            centered: Boolean,
        },

        components: {
            QPage
        },

        // computed: {
        //     // ...mapGetters({
        //     //     locale: 'lang/locale',
        //     //     locales: 'lang/locales',
        //     //     user: 'auth/user',
        //     // }),

        //     menus() {
        //         return window.config.menus
        //     }
        // },

        created() {
          window.addEventListener('beforeunload', this.$watchUser('closed'))
          this.checkAge()
        },
        
        beforeDestroy() {
          this.$watchUser('redirect')
        },

        mounted() {
            localStorage.setItem(this.$route.path, moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss'))
            // if (this.lang !== 'langAR'){
            //     this.lang = 'langEN'
            // }
        },

        methods: {
            // setLocale(locale) {
            //     if (this.$i18n.locale !== locale) {
            //         loadMessages(locale)
            //         this.$store.dispatch('lang/setLocale', {locale})
            //     }
            // },
            checkAge() {
                if (document.cookie.indexOf('cookie_notice_accepted') < 0) {
                    let date = moment().format("HH")
                    let day = moment().format('dddd')
                    if (date > '08' && date < '19' && day !== 'Sábado' && day !== 'Domingo') {
                        this.$router.push('/ageVerification')
                    } else {
                        Cookies.set('cookie_notice_accepted', true, {expires: 1,path: '/'})
                    }
                }
            },
            yourClickHandler(event) {
              let clickNow = {
                'data': Array(event.target.outerHTML),
                'date': moment(document.lastModified, 'YYYY-MM-DD HH:mm:ss')
              }
              let parsed = JSON.stringify(clickNow)
              localStorage.setItem('click', parsed)
              if (!localStorage.getItem('item'))
                this.$watchUser('click')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Page.vue